module.exports = __webpack_public_path__ + "static/media/ic_x_2.fdca5466.svg";